module.exports = __webpack_public_path__ + "static/media/LgPic.0da54c27.svg";